import { styled } from "@mui/material";

export const StyledDropzone = {
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing(1),
  })),
  DropZoneBase: styled("div")(({ theme, isActive, isAccept, isReject }) => ({
    flex: 1,
    display: "flex",
    width: "100%",
    padding: theme.spacing(6),
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 2,
    borderRadius: theme.shape.borderRadius,
    borderColor: "#a1a1a1",
    borderStyle: "dashed",
    backgroundColor: "#f7f7f7",
    color: "#858585",
    outline: "none",
    transition: "border .24s ease-in-out",
    borderColor: isActive
      ? "#2196f3"
      : isAccept
      ? "#00e676"
      : isReject
      ? "#ff1f4a"
      : "#a1a1a1",
  })),
};
